import React from 'react';

const Logo = ({ size = 40 }) => {
  return (
    <div className="flex items-center gap-2.5">
      <div
        className="relative flex items-center justify-center rounded-full"
        style={{
          width: size,
          height: size,
          background: 'radial-gradient(circle at 30% 30%, #7ee7a3, #0e6b3a 65%, #063a20)',
          boxShadow: '0 0 24px rgba(34, 197, 94, 0.35), inset 0 0 12px rgba(0,0,0,0.4)',
        }}
      >
        <svg viewBox="0 0 24 24" width={size * 0.55} height={size * 0.55} fill="none" stroke="#062a17" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3c4 4 6 8 6 12a6 6 0 1 1-12 0c0-4 2-8 6-12z" fill="#0a3d22" />
          <path d="M12 8c-1.2 2-2 4-2 6" stroke="#c6f6d5" />
        </svg>
      </div>
      <span className="font-semibold tracking-tight text-[17px] text-white">
        SkyWay <span className="text-emerald-400">Green</span>
      </span>
    </div>
  );
};

export default Logo;
